import { inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  StaysFormData,
  StaysWidget
} from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  AirportSearchErrorService,
  HeaderFooterMachCoreContentService,
  LoggingService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BookingStaysAdapterService } from '../../adapters/booking-stays/booking-stays-adapter.service';
import { StaysLocationItem } from '../../models/interface/booking-stays/stays-interface';
import { StaysApiService } from '../../services/booking-stays/stays-api.service';
import { BookingStaysFormService } from '../../utils/booking-stays/booking-stays-form.service';

@Injectable({
  providedIn: 'root'
})
export class BookingStaysFacadeService {
  staysWidgetForm!: FormGroup;
  formService = inject(BookingStaysFormService);
  content = inject(HeaderFooterMachCoreContentService);
  adapter = inject(BookingStaysAdapterService);
  loggingService = inject(LoggingService);
  searchApiService = inject(StaysApiService);
  airportSearchErrorService = inject(AirportSearchErrorService);
  staysWidgetContent$ = new BehaviorSubject<StaysWidget>({} as StaysWidget);

  showAlert = false;

  init(): void {
    this.staysWidgetForm = this.formService.createBookingForm();
    this.content
      .getHeaderFooterMachCoreContent$()
      .pipe(
        catchError((error) => {
          const errorMessage = `AEM API failed: ${error.message}`;
          this.loggingService.log(errorMessage);
          this.showAlert = true;
          return of(null);
        })
      )
      .subscribe((aemResponse) => {
        if (aemResponse?.header?.book?.stays) {
          const errorMsg =
            aemResponse?.header?.book.stays?.labels
              ?.predictiveCitiesNoResults || '';
          this.airportSearchErrorService.setErrorMessageFromAEM(errorMsg);
          this.staysWidgetContent$.next(this.adapter.getContent(aemResponse));
        } else {
          this.showAlert = true;
        }
      });
  }

  formSubmitted(mdpcid: string): void {
    const formValues: StaysFormData = this.staysWidgetForm.getRawValue();
    const adultsPerRoom = this.formService.distributedPassengersToRooms(
      formValues.numberOfTravelers,
      formValues.numberOfRooms
    );
    this.formService.navigateToStaysSearch(formValues, adultsPerRoom, mdpcid);
  }

  searchLocations(query: string): Observable<StaysLocationItem[]> {
    return this.searchApiService.searchLocations(query);
  }
}
